<template>
    <v-container class="wrapper-ticket-message pa-0">
        <!-- no ticket selected + not create new ticket -->
        <v-container
            v-if="(!isTicketSelected && messages.length == 0 && !isCreateNewTicket && !createNewTicket)"
            class="wrapper-view pa-0"
        >
            <img src="@/assets/ticket/bg-ticket.png" />
            <div class="layer">
                <img src="@/assets/ticket/layer-1.png" />
                <v-container class="pa-0">
                    <v-card-text class="text-h2 pa-0 text-center">{{ $t('choose a message') }}</v-card-text>
                    <v-card-text class="text-h4 pa-0 text-center mt-3" style="color: #7c7979;">{{ $t('or create a new message') }}</v-card-text>
                    <v-container class="text-center mt-3 pa-0">
                        <v-btn
                            custom
                            depressed
                            color="primary"
                            @click="createNewTicketHandler()"
                        >
                            <span>{{ $t('new ticket') }}</span>
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-container>
                </v-container>
            </div>
        </v-container>
        <!--create new ticket-->
        <v-container
            v-if="(!isTicketSelected && messages.length == 0 && isCreateNewTicket) || (!isTicketSelected && messages.length == 0 && createNewTicket)"
            class="wrapper-create-ticket pa-0"
        >
            <v-container class="d-flex justify-space-between align-center pa-0">
                <v-card-text class="text-h3 pa-0">{{ $t("creating new ticket") }}</v-card-text>
                <v-btn
                    color="error"
                    custom
                    outlined
                    @click="isDialogVisible = true"
                >
                {{ $t('cancel ticket') }}
                </v-btn>
            </v-container>
            <v-form
                ref="form"
                class="pa-0 mt-4"
            >
                <v-text-field
                    :label="$t('ticket title')"
                    v-model="ticketTitle"
                    outlined
                    dense
                    clearable
                    :rules="[v => !!v || $t('is-required')]"
                    class="mb-8"
                />
                <autocomplete
                    v-model="department"
                    :title="$t('departments')"
                    type="departments"
                    :value="department"
                    :rules="[v => !!v || $t('is-required')]"
                />
            </v-form>
        </v-container>
        <!-- create new ticket + continuing ... -->
        <v-container class="wrapper-relative-conversation pa-0">
            <v-container
                v-if="resolveDisplay()"
                class="wrapper-conversation pa-0"
                :style="resolveWrapperHeight()"
                :class="{ '': (isTicketSelected && messages.length > 0) || (!isTicketSelected && messages.length > 0) || (isTicketSelected && messages.length == 0) , 'mt-8': (!isTicketSelected && messages.length == 0 && isCreateNewTicket) || (!isTicketSelected && messages.length == 0 && createNewTicket) }"
            >
                <!--header-->
                <v-container
                    v-if="(isTicketSelected && messages.length > 0) || (!isTicketSelected && messages.length > 0) || (isTicketSelected && messages.length == 0)"
                    class="header pa-3"
                >
                    <!-- selected ticket -->
                    <v-container
                        v-if="(isTicketSelected && messages.length > 0) || (isTicketSelected && messages.length == 0)"
                        class="pa-0"
                    >
                        <div class="d-flex justify-space-between align-center">
                            <div class="d-flex gap-2">
                                <span class="text-h4">#{{ selectedTicket.id }}</span>
                                <span class="text-h4">{{ selectedTicket.title ? selectedTicket.title : 'تیکت جدید' }}</span>
                            </div>
                            <div>
                                <v-card-text class="text-body-2 pa-0">{{ selectedTicket.time }}</v-card-text>
                            </div>
                        </div>
                        <div class="d-flex justify-space-between align-center mt-2">
                            <div class="d-flex gap-1">
                                <!--<span class="text-h4">departman ticket</span>-->
                                <v-card-text class="text-body-2 pa-0">{{ selectedTicket.user ? selectedTicket.user.firstname : '-' }} {{ selectedTicket.user ? selectedTicket.user.lastname : '-'}}</v-card-text>
                            </div>
                            <v-btn
                                color="error"
                                custom
                                outlined
                                @click="isDialogVisible = true"
                            >
                            {{ $t('close ticket') }}
                            </v-btn>
                        </div>
                    </v-container>
                    <!-- not selected ticket (creating ticket)-->
                    <v-container
                        v-if="!isTicketSelected && messages.length > 0"
                        class="pa-0"
                    >

                        <div class="d-flex justify-space-between align-center">
                            <div class="d-flex gap-2">
                                <span class="text-h4">#{{ messages[messages.length - 1].ticket_id }}</span>
                                <span class="text-h4">{{ ticketTitle ? ticketTitle : 'تیکت جدید' }}</span>
                            </div>
                            <div>
                                <v-card-text class="text-body-2 pa-0">{{ messages[messages.length - 1].time }}</v-card-text>
                            </div>
                        </div>
                        <div class="d-flex justify-space-between align-center mt-2">
                            <v-card-text class="text-body-2 pa-0">{{ messages[messages.length - 1].user ? messages[messages.length - 1].user.firstname : '-' }} {{ messages[messages.length - 1].user ? messages[messages.length - 1].user.lastname : '-' }}</v-card-text>
                            <v-btn
                                color="error"
                                custom
                                outlined
                                @click="isDialogVisible = true"
                            >
                            {{ $t('close ticket') }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-container>
                <!--body-->
                <v-container class="body pa-0">
                    <!-- create new ticket -->
                    <v-container
                    class="layer pa-0"
                    v-if="(!isTicketSelected && messages.length == 0 && isCreateNewTicket) || (!isTicketSelected && messages.length == 0 && createNewTicket)"
                    >
                        <div class="text-center">
                            <img src="@/assets/ticket/layer-2.png" />
                        </div>
                        <v-card-text class="text-h2 pa-0 text-center">{{ $t("there is no message yet") }}</v-card-text>
                        <v-card-text class="text-h4 pa-0 mt-3 text-center" style="color: #7c7979;">{{ $t("write your message") }}</v-card-text>
                    </v-container>
                    <!-- showing message -->
                    <v-container
                    class="pa-0"
                    v-if="(!isTicketSelected && messages.length > 0) || (isTicketSelected && messages.length > 0)"
                    >
                        <MessageBox
                            v-if="messages != undefined && messages.length > 0"
                            :messages="messages"
                        />
                    </v-container>
                </v-container>
                <!--footer-->
                <v-container class="footer pa-0">
                    <SendMessage
                        :isTicketSelected="isTicketSelected"
                        :messages="messages"
                        @fileAttach="fileAttach"
                        @submit="submitMsgHandler"
                        @checkFormValidate="checkFormValidator"
                        :isFormValid="isFormValid"
                        :toggleSelectionTicket="toggleSelectionTicket"
                        :isMessageSend="isMessageSend"
                        :isTicketCanceled="isTicketCanceled"
                    />
                </v-container>
            </v-container>
            <!--loading messages-->
            <transition name="fade">
                <v-container
                    class="wrapper-loading pa-0"
                    v-if="loading"
                >
                    <v-progress-circular
                        indeterminate
                        color="white"
                    >
                    </v-progress-circular>
                </v-container>
            </transition>
        </v-container>
        <!--dialog (cancel) + (close) ticket-->
        <v-dialog
            v-model="isDialogVisible"
            max-width="500px"
            max-height="400"
        >
            <v-card class="px-7 py-6">
                <v-container class="d-flex justify-space-between align-center pa-0">
                    <v-card-text class="text-body-2 pa-0">{{ resolveTicketStatusTitle }}</v-card-text>
                    <v-icon
                        style="cursor: pointer;"
                        @click="isDialogVisible = false"
                    >
                    mdi-close
                    </v-icon>
                </v-container>
                <v-card-text class="text-body-1 pa-0 py-9">{{ resolveTicketStatusText }}</v-card-text>
                <v-card-actions class="pa-0">
                    <v-container class="pa-0 d-flex justify-center gap-2">
                        <v-btn
                        custom
                        outlined
                        class="flex-fill"
                        @click="isDialogVisible = false"
                        >
                            <span>خیر</span>
                        </v-btn>
                        <v-btn
                        custom
                        depressed
                        color="error flex-fill"
                        @click="pauseTicket"
                        >
                            <span>{{ resolveTicketStatusConfirmText }}</span>
                        </v-btn>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import MessageBox from '@/views/dashboard/pages/ticket/partial/message/MessageBox.vue'
import SendMessage from '@/views/dashboard/pages/ticket/partial/message/SendMessage.vue'

export default {
  props: {
    messages: Array,
    isTicketSelected: Boolean,
    selectedTicket: Object,
    isCreateNewTicket: Boolean,
    toggleSelectionTicket: Boolean,
    isMessageSend: Boolean,
    loading: Boolean
  },
  data () {
    return {
      ticketTitle: null,
      fileType: null,
      isFileAttached: false,
      createNewTicket: false,
      department: null,
      selectedDepartmentId: null,
      isFormValid: false,
      isDialogVisible: false,
      isTicketCanceled: false
    }
  },
  computed: {
    resolveTicketStatusTitle () {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t('cancel ticket')
      } else {
        return this.$t('close ticket')
      }
    },
    resolveTicketStatusText () {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t('Are you sure you want to cancel this ticket?')
      } else {
        return this.$t('Are you sure you want to close this ticket?')
      }
    },
    resolveTicketStatusConfirmText () {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t('cancel the ticket')
      } else {
        return this.$t('close the ticket')
      }
    }
  },
  components: {
    MessageBox,
    SendMessage
  },
  methods: {
    submitMsgHandler (value) {
      this.$emit('submit', { value, ticketTitle: this.ticketTitle })
    },
    closeTicket () {
      this.$emit('closeTicket', this.messages[0].ticket_id)
    },
    fileAttach (value) {
      // value: {files}
      this.isFileAttached = true
      this.$emit('fileAttach', value.files)
    },
    resolveDisplay () {
      if ((!this.isTicketSelected && this.messages.length === 0 && this.isCreateNewTicket) || (!this.isTicketSelected && this.messages.length === 0 && this.createNewTicket) || (this.isTicketSelected && this.messages.length > 0) || (!this.isTicketSelected && this.messages.length > 0) || (this.isTicketSelected && this.messages.length === 0)) {
        return true
      }
    },
    resolveWrapperHeight () {
      let height = ''
      if ((!this.isTicketSelected && this.messages.length === 0 && this.isCreateNewTicket) || (!this.isTicketSelected && this.messages.length === 0 && this.createNewTicket)) {
        height = '53vh'
      }
      if ((this.isTicketSelected && this.messages.length > 0) || (!this.isTicketSelected && this.messages.length > 0) || (this.isTicketSelected && this.messages.length === 0)) {
        height = '77vh'
      }
      return {
        height: height
      }
    },
    createNewTicketHandler () {
      this.createNewTicket = true
    },
    checkFormValidator () {
      if (!this.$refs.form.validate()) return false
      if (this.$refs.form.validate()) {
        this.isFormValid = true
      }
    },
    pauseTicket () {
      if (!this.isTicketSelected && this.messages.length === 0 && (this.isCreateNewTicket || this.createNewTicket)) {
        this.ticketTitle = null
        this.department = null
        this.isTicketCanceled = !this.isTicketCanceled
        this.isDialogVisible = false
      } else {
        console.log('test 2')
      }
    }
  },
  watch: {
    isCreateNewTicket (val) {
      this.ticketTitle = null
      this.department = null
      this.selectedDepartmentId = null
    },
    department (val) {
      if (val) {
        this.selectedDepartmentId = val.id
        this.$emit('onSelectedDepartment', this.selectedDepartmentId)
      }
    }
  }
}
</script>

<style scoped>
.wrapper-ticket-message .wrapper-view {
    border: 1px solid #999999;
    border-radius: 8px;
    height: 77vh;
    position: relative;
}
.wrapper-ticket-message .wrapper-view img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
.wrapper-ticket-message .wrapper-view .layer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.wrapper-ticket-message .wrapper-view .layer img {
    width: 330px;
    height: 255px;
}
.wrapper-ticket-message .wrapper-conversation {
    border: 1px solid #999999;
    border-radius: 8px;
    position: relative;
    background: url('../../../../../../assets/ticket/bg-ticket.png');
    display: flex;
    flex-direction: column;
}
.wrapper-ticket-message .wrapper-conversation .header {
    display: flex;
    flex-direction: column;
    gap: .25rem;
    border-bottom: 1px solid #999999;
    background-color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 88px;
}
.wrapper-ticket-message .wrapper-conversation .body {
    display: flex;
    align-items: end;
    flex-direction: column-reverse;
    overflow-y: auto;
    height: 61.5vh;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar {
  width: 4px;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-thumb {
  background: #8888889f;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body .layer {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.wrapper-ticket-message .wrapper-conversation .body .layer img {
    width: 190px;
}
.wrapper-ticket-message .wrapper-conversation .footer {
    /* position: absolute;
    bottom: 0; */
    border-top: 1px solid silver;
    background-color: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.wrapper-ticket-message .wrapper-relative-conversation {
    position: relative;
}
.wrapper-ticket-message .wrapper-relative-conversation .wrapper-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: #c0c0c063;
    height: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.wrapper-ticket-message .wrapper-relative-conversation .fade-enter-active,
.wrapper-ticket-message .wrapper-relative-conversation .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.wrapper-ticket-message .wrapper-relative-conversation .fade-enter,
.wrapper-ticket-message .wrapper-relative-conversation .fade-leave-to {
  opacity: 0;
}
</style>
